import type { DeviceAllowedCodeLength } from "./types";

export const PERSONAL_INFORMATION = "personal_information";

export const BREAKPOINT_SMALL = 320;
export const BREAKPOINT_SMALL_LARGE = 768;
export const BREAKPOINT_MEDIUM = 960;
export const BREAKPOINT_LARGE = 1280;

export const PLOOM_DARK_NAVY = "#00202c";

export const DATE_FORMAT = "MMM DD YYYY";
export const DOB_DATE_FORMAT = "DD MMMM YYYY";
export const DOB_INPUT_DATE = "DD.MM.YYYY";
export const ISO_DATE_FORMAT = "YYYY-MM-DD";

export const DEVICE_CODE_POSSIBLE_LENGTH = {
  SHORT: 12,
  LONG: 16,
  GEN4: 15,
} as const;

export const FORMATTED_CODE_POSSIBLE_LENGTH = {
  [DEVICE_CODE_POSSIBLE_LENGTH.SHORT]: 14,
  [DEVICE_CODE_POSSIBLE_LENGTH.LONG]: 19,
  [DEVICE_CODE_POSSIBLE_LENGTH.GEN4]: 17,
} as const;

export const DEFAULT_ALLOWED_DEVICE_CODE_LENGTH: DeviceAllowedCodeLength[] = [DEVICE_CODE_POSSIBLE_LENGTH.LONG];

export const DEVICE_CODE_REGEX = /^(([A-Za-z0-9]{4} ?){3,4}|([A-Za-z0-9]{5} ?){3})$/;
export const DEVICE_SERIAL_NUMBER_QUERY_PARAM = "s";

export const REGISTER_SUCCESS = "register-success";

export const DES_AK_TENANT_TOKEN = "X-DES-AK-TENANT-TOKEN";
export const DES_EVO_TENANT_TOKEN = "X-DES-TENANT";
export const DES_I_AM_TOKEN = "X-DES-CONSUMER-IAM-TOKEN";
export const DES_EVO_USER_TOKEN = "X-DES-USER-TOKEN";
export const DES_RECAPTCHA_TOKEN = "X-DES-RECAPTCHA-TOKEN";

export const KAKAO_AUTH_STRATEGY = "kakao-credential";
export const EMAIL_AUTH_STRATEGY = "email-credential";
export const PHONE_AUTH_STRATEGY = "phone-number-credential";

export const LOCAL_USER_UPDATED_EVENT = "localstorage-user-updated";
export const LOCAL_USER_SESSION_EXPIRED_EVENT = "user-session-expired";
